import React from 'react';

export default function Logo(){
    return (
        <img 
            className="intro-logo"
            src="./icons/logo.svg"
            alt="Logo"
        />
    )};